import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { Route } from '@/modules/core/enums/route.enum.ts';
import { saveUrlForErrorPage } from '@/modules/core/utils/save-url-for-error-page.ts';
import { Access } from '@/modules/common/enums/access.enum.ts';
import { createNavigationGuard } from '@/router.guard.ts';

const routes: RouteRecordRaw[] = [];

if (import.meta.env.VITE_BUILD_DEV_PAGES === '1') {
  routes.push({
    path: '/icons-preview',
    name: Route.IconsPage,
    component: () => import('@/modules/core/components/IconsPage.vue'),
    meta: {
      tabTitle: 'core.icons.title',
      auth: false,
    },
  });

  routes.push({
    path: '/error-preview',
    name: Route.ErrorPreviewPage,
    component: () => import('@/modules/core/components/ErrorPreviewPage.vue'),
    meta: {
      tabTitle: 'core.pages.error.title.default',
      auth: false,
    },
  });
}

routes.push(
  {
    path: '/login',
    name: Route.LoginPage,
    component: () => import('@/modules/core/components/LoginPage.vue'),
    meta: {
      tabTitle: 'core.login.title',
      auth: false,
    },
  },
  {
    path: '/assignments',
    name: Route.AssignmentsPage,
    component: () => import('@/modules/assignment/components/AssignmentPage.vue'),
    meta: {
      tabTitle: 'assignment.title',
    },
  },
  // TODO: удалить — редирект для пользователей, сохранивших старый путь в закладки
  {
    path: '/commissions',
    redirect: '/assignments',
  },
  {
    path: '/search/assignments',
    name: Route.AssignmentsSearchPage,
    component: () => import('@/modules/assignment/components/AssignmentSearchPage.vue'),
    meta: {
      tabTitle: 'assignment.search.title',
      access: Access.DocumentsView,
    },
  },
  {
    path: '/control',
    name: Route.ControlPage,
    component: () => import('@/modules/control/components/ControlPage.vue'),
    meta: {
      tabTitle: 'control.title',
      access: Access.DocumentsControl,
    },
  },
  {
    path: '/search',
    name: Route.SearchPage,
    component: () => import('@/modules/search/components/SearchPage.vue'),
    meta: {
      tabTitle: 'search.title',
      access: Access.DocumentsView,
    },
  },
  {
    path: '/counterparties',
    name: Route.CounterpartiesPage,
    component: () => import('@/modules/counterparty/components/CounterpartiesPage.vue'),
    meta: {
      tabTitle: 'counterparty.title.list',
      access: Access.CounterpartiesRegionsSegmentsView,
    },
  },
  {
    path: '/document/:id',
    name: Route.DocumentPage,
    component: () => import('@/modules/document/components/DocumentPage.vue'),
    meta: {
      tabTitle: 'document.pages.documentPrint.defaultTitle',
      access: Access.DocumentsView,
    },
  },
  {
    path: '/document-print/:id',
    name: Route.DocumentPrintPage,
    component: () => import('@/modules/document/pages/DocumentPrintPage.vue'),
    meta: {
      tabTitle: 'document.title',
      access: Access.DocumentsView,
    },
  },
  {
    path: '/client/:id',
    name: Route.CounterpartyPage,
    component: () => import('@/modules/counterparty/components/CounterpartyPage.vue'),
    meta: {
      tabTitle: 'counterparty.title.item',
      access: Access.CounterpartiesRegionsSegmentsView,
    },
  },
  {
    path: '/file-editor/:id',
    name: Route.FileEditorPage,
    component: () => import('@/modules/document/pages/FileEditorPage.vue'),
    meta: {
      tabTitle: 'document.title',
      access: Access.DocumentsEdit,
    },
  },
  {
    path: '/favorite-redirect/:id',
    name: Route.FavoriteRedirectPage,
    component: () => import('@/modules/favorite/components/FavoriteRedirectPage.vue'),
    meta: {
      tabTitle: 'favorite.redirect',
    },
  },
  {
    path: '/',
    redirect: {
      name: Route.LoginPage,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: Route.ErrorPage,
    component: () => import('@/modules/core/components/ErrorPage.vue'),
    meta: {
      tabTitle: 'core.pages.error.title.default',
    },
  }
);

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: '_active',
  linkExactActiveClass: '_exact-active',
});

router.afterEach(saveUrlForErrorPage);

router.beforeEach(createNavigationGuard());

export default router;
